<template>
  <BDropdown variant="none" toggle-class="custom-dropdown" no-caret>
    <template #button-content>
      <div class="d-flex">{{ selected.text }}<img src="@/assets/img/arrow_drop_down.svg" /></div>
    </template>
    <BDropdownItem v-for="(option, index) in options" :key="index" @click="inputVal = option.value">
      <img v-if="option.img" class="mr-2" :src="require(`@/assets/img/${option.img}`)" />
      <span>{{ option.text }}</span>
    </BDropdownItem>
  </BDropdown>
</template>

<script>
import { BDropdown, BDropdownItem } from 'bootstrap-vue';
import vModelMixin from '@/mixins/v-model';

export default {
  name: 'DropDown',
  mixins: [vModelMixin],
  props: {
    options: {
      type: Array,
      required: true,
    },
  },
  computed: {
    selected() {
      return this.options.find((option) => option.value === this.inputVal);
    },
  },
  components: {
    BDropdown,
    BDropdownItem,
  },
};
</script>

<style lang="scss" scoped>
::v-deep {
  .btn {
    &:focus {
      box-shadow: none;
    }
  }
  .custom-dropdown {
    color: #174169;
    font-size: 1.125rem;
    letter-spacing: 0;
  }

  .dropdown-menu {
    min-width: 0;
  }
}
</style>
